export default __webpack_public_path__ + "static/media/Primera.f11599c9.jpg";